import restify from './restify';
export default restify('customers');
